import axios from "axios";

// State global untuk menyimpan konfigurasi
let thirdPartyInstance = null;
let integrationSettings = {};

// Fungsi untuk mendapatkan nilai berdasarkan path dinamis
const getNestedValue = (obj, path) => {
  return path.split(".").reduce((acc, key) => acc?.[key], obj);
};

// Fungsi untuk menginisialisasi instance axios berdasarkan konfigurasi
export const initializeThirdParty = (settings) => {
  if (!settings?.integration?.isEnable) {
    console.warn("Third-party integration is disabled.");
    thirdPartyInstance = null;
    return;
  }

  integrationSettings = settings.integration;

  thirdPartyInstance = axios.create({
    baseURL: integrationSettings.url,
    headers: {
      ...integrationSettings.header,
      "Content-Type": "application/json",
    },
  });

  console.log(
    "Third-party integration initialized with URL:",
    integrationSettings.url,
  );
};

// Fungsi untuk mengirim klaim voucher dengan key dinamis
export const updateMultipleVoucherClaims = async (voucherData) => {
  if (!thirdPartyInstance) {
    console.error("Third-party integration is not enabled or configured.");
    return;
  }

  try {
    const timestampNow = new Date().toISOString();

    // Ambil path key untuk uvc & timestamp dari settings
    const uvcPath = integrationSettings.body.uvcs[0].uvc;
    const timestampPath = integrationSettings.body.uvcs[0].timestamp;

    // Mapping data dengan path dinamis
    const payload = {
      uvcs: voucherData.map((data) => ({
        uvc: getNestedValue(data, uvcPath),
        timestamp: getNestedValue(data, timestampPath) || timestampNow,
      })),
    };

    const response = await thirdPartyInstance.post("", payload);
    return response.data;
  } catch (error) {
    console.error(
      "Error updating voucher claims:",
      error.response?.data || error.message,
    );
    throw error;
  }
};
